module.exports = "<div class=home-column-wrapper> <home-column ng-if=\"$ctrl.showClientAdminHome || $ctrl.showUserAdminHome\" icon=\"'fa-users'\" links=$ctrl.adminLinks title=\"'Admin'\"> </home-column> <home-column ng-if=$ctrl.showFacilityAdminHome icon=\"'fa-wrench'\" links=$ctrl.facilityLinks hide-column=!true title=\"'Facilities'\"> </home-column> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/home/user-home/user-home.html
// module id = 392
// module chunks = 0